import dayjs from "dayjs";

export type QueryFilter = [column: string, operator: string, value: unknown];

interface MakeQueryFilterInParams<T, K extends keyof T> {
  items: T[];
  filterKey: string;
  byItemKey?: K;
}
export const makeQueryFilterIn = <T, K extends keyof T>({
  items,
  filterKey,
  byItemKey,
}: MakeQueryFilterInParams<T, K>): QueryFilter | undefined => {
  if (items.length <= 0) return undefined;
  let queryFilter: QueryFilter | undefined = undefined;
  if (byItemKey) {
    queryFilter = [filterKey, "in", `(${items.map((item) => item[byItemKey]).join(",")})`];
  } else {
    queryFilter = [filterKey, "in", `(${items.join(",")})`];
  }
  return queryFilter;
};

interface MakeQueryFilterNotInParams<T, K extends keyof T> {
  items: T[];
  filterKey: string;
  byItemKey?: K;
}
export const makeQueryFilterNotIn = <T, K extends keyof T>({
  items,
  filterKey,
  byItemKey,
}: MakeQueryFilterNotInParams<T, K>): QueryFilter | undefined => {
  if (items.length <= 0) return undefined;
  let queryFilter: QueryFilter | undefined = undefined;
  if (byItemKey) {
    queryFilter = [filterKey, "not.in", `(${items.map((item) => item[byItemKey]).join(",")})`];
  } else {
    queryFilter = [filterKey, "not.in", `(${items.join(",")})`];
  }
  return queryFilter;
};

// used for or-filters
export const makeDottedQueryFilter = (filter: QueryFilter | undefined) => {
  if (!filter) return;
  return filter.join(".");
};

export const makeBetweenDatesQueryFilter = (
  field: string,
  from?: Date | string | null,
  until?: Date | string | null,
): QueryFilter[] => {
  if (!from || !until || !field) return [];
  const start_date = dayjs(from);
  const end_date = dayjs(until);
  return [
    [field, "gt", start_date.startOf("day").toISOString()],
    [field, "lt", end_date.endOf("day").toISOString()],
  ];
};
